import request from '../config/axiosConfig';
import { LOGIN, LOGOUT } from '../constants/apiEndPoint';

export const loginRequest = async (data) => {
  const result = await request({
    url: LOGIN,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const logoutRequest = () => {
  return request({
    url: LOGOUT,
    method: 'POST'
  });
};

// export const updateInfoRequest = (data) => {
//   return request({
//     url: UPDATE_INFO,
//     method: 'POST',
//     data
//   });
// };
